// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/navigation/workspace/app/css/app.css
// module id = 767
// module chunks = 0